import { useCallback } from 'react';
import Image from 'next/image';
import { Button } from '@cbhq/cds-web/buttons';
import { HeroSquare } from '@cbhq/cds-web/illustrations/HeroSquare';
import { VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextHeadline } from '@cbhq/cds-web/typography';

export function FullscreenError() {
  const handleAction = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <VStack height="100vh" background="bg">
      {/* Header */}
      <VStack paddingY={2} paddingX={4}>
        <Image src="/assets/images/coinbase-logo.svg" alt="Coinbase Logo" width={36} height={36} />
      </VStack>
      {/* Error Content */}
      <VStack alignItems="center" justifyContent="center" flexGrow={1}>
        <VStack alignItems="center" width={325} gap={4}>
          <HeroSquare name="errorRefresh" />

          <TextHeadline as="h3" textAlign="center" display="block">
            Service Unavailable
          </TextHeadline>

          <TextBody as="p" color="fgMuted" textAlign="center" display="block">
            We encountered a problem with our servers. Please try refreshing.
          </TextBody>

          <Button variant="primary" onClick={handleAction} block>
            Go back and try again
          </Button>
        </VStack>
      </VStack>
    </VStack>
  );
}
